import { render } from "./simple-facility-card.vue?vue&type=template&id=8966f4fe&scoped=true"
import script from "./simple-facility-card.vue?vue&type=script&lang=js"
export * from "./simple-facility-card.vue?vue&type=script&lang=js"

import "./simple-facility-card.vue?vue&type=style&index=0&id=8966f4fe&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8966f4fe"]])

export default __exports__